<!-- Page Header -->
<app-page-header
  title="Anmeldung"
  subtitle="Melden Sie sich mit Ihrem Kundenkonto an"
  icon="login"
  variant="gradient">
</app-page-header>

<!-- Apple-style Login Selection -->
<div class="apple-login-selection-wrapper apple-fade-in">
  <div class="apple-container">
    <!-- Login Options Grid -->
    <div class="login-options-grid apple-slide-up">
      <!-- Customer Login Card -->
      <div class="apple-card login-option-card customer-card single-card">
        <div class="card-icon-wrapper customer">
          <mat-icon class="card-icon">person</mat-icon>
        </div>

        <h2 class="apple-heading-3">Kundenanmeldung</h2>
        <p class="apple-body-secondary card-subtitle">
          Bestehende Kunden mit registrierten Konten
        </p>

        <div class="card-content">
          <p class="apple-body">
            Verwenden Sie Ihre E-Mail und Ihr Passwort, um auf Ihr Kundenkonto zuzugreifen.
          </p>
          <ul class="feature-list">
            <li class="feature-item">
              <mat-icon class="feature-icon">check_circle</mat-icon>
              <span class="apple-body-small">Bestellungen und Transaktionen ansehen</span>
            </li>
            <li class="feature-item">
              <mat-icon class="feature-icon">check_circle</mat-icon>
              <span class="apple-body-small">Coin-Guthaben verwalten</span>
            </li>
            <li class="feature-item">
              <mat-icon class="feature-icon">check_circle</mat-icon>
              <span class="apple-body-small">Kundensupport kontaktieren</span>
            </li>
          </ul>
        </div>

        <button
          class="apple-button apple-button-primary apple-button-large"
          (click)="navigateToCustomerLogin()">
          <mat-icon>login</mat-icon>
          Kundenanmeldung
        </button>
      </div>
    </div>
  </div>
</div>
